import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { ContentServiceV2 as ContentService } from '../../_shared/services/api/api-index';
import { HtmlContentModel } from '../../_shared/models/models-index';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { LocaleService } from '../../_shared/locale/locale.service';

@Component({
    selector: 'navbar-support',
    templateUrl: './support.component.html',
    standalone: false
})

export class SupportModalComponent {
  locale: string;
  supportContent$: Observable<string>;

  constructor(
    public dialogRef: MatDialogRef<SupportModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private contentService: ContentService,
    private localeService: LocaleService,
  ) {
    // get locale
    this.supportContent$ = this.localeService.locale$.pipe(
      filter(loc => !!loc),
      switchMap(locale => {
        this.locale = locale;
        // now get content from the v5 api
        return this.contentService.getContent('Support', locale).pipe(
          map(content => content.value),
          catchError(_ => of('No Help Content Available')),
        )
      })
    );
  }

  closeModal() {
    this.dialogRef.close();
  }

}
